<template>
  <section>
    <br>
    <p class="p-style">
      Step 4: Review Details
    </p>
    <div class="steps-div">
      <p class="steps-name">
        Location Verification<v-icon
          right
          size="18"
          color="#2E7D32"
        >
          mdi-checkbox-marked-circle
        </v-icon>
      </p>
      <p class="steps-name">
        Gather Visit Status<v-icon
          right
          size="18"
          color="#2E7D32"
        >
          mdi-checkbox-marked-circle
        </v-icon>
      </p>
    </div>
    <v-card
      class="card-style"
      color="#ECEFF1"
      :style="getBgStyle"
    >
      <v-card-text>
        <v-form>
          <div>
            <v-card
              class="user-card"
              light
            >
              <p class="user-content">
                Check-Out Location:- <font
                  v-if="locationName.site_name !== undefined"
                  class="font-my-style"
                >
                  {{ locationName.site_name }}
                </font>
                <font v-else>
                  N/A
                </font>
              </p>
              <p class="user-content">
                Work Clock:-
                <check-in-clock style="color:#FF3700; font-size:16px;" />
              </p>
            </v-card>
            <p class="invoice-Style">
              Is the visit's purpose complete?
            </p>
            <v-radio-group
              v-model="visitStatus.visit_status"
              row
              light
              readonly
            >
              <v-radio
                label="Pending"
                value="pending"
                light
                color="#FF3700"
              >
                <template #label>
                  <span class="input__label">Pending</span>
                </template>
              </v-radio>
              <v-radio
                label="Completed"
                value="completed"
                light
                color="#FF3700"
              >
                <template #label>
                  <span class="input__label">Completed</span>
                </template>
              </v-radio>
            </v-radio-group>
            <p class="reason-style">
              Reason:- <font
                v-if="visitStatus.pending_reason !== null"
                class="font-my-style"
              >
                {{ visitStatus.pending_reason }}
              </font>
              <font
                v-else
                class="font-my-style"
              >
                N/A
              </font>
            </p>
          </div>
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="#37474F"
            @click="cancel()"
          >
            Cancel
          </v-btn>
          <v-btn
            color="#FF3700"
            @click="checkOut()"
          >
            Check Out
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card-text>
    </v-card>
    <br>
    <centre-spinner
      :loading="loading"
    />
  </section>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';
import moment from 'moment';
import CheckInClock from '../../Checkin/CheckInClock.vue';

export default {
  name: 'ReviewVisitorCheckOut',
  components: {
    'centre-spinner': spinner,
    'check-in-clock': CheckInClock,
  },
  data: () => ({
    loading: false,
    cardBgImg: require('@/assets/img/cardBg.png'),
  }),
  computed: {
    getBgStyle () {
      return `background-image: linear-gradient(rgba(255,255,255,.6), rgba(255,255,255,.6)), url(${this.cardBgImg});`;
    },
    visitStatus () {
      return this.$store.getters['swiftuser/getVisitStatus'];
    },
    activeCheckInDetails () {
      return this.$store.getters['swiftuser/getActiveCheckInDetails'];
    },
    locationName () {
      return this.$store.getters['swiftuser/getLocationName'];
    },
    checkoutType () {
      return this.$store.getters['swiftuser/getCheckoutType'];
    },
    manualCheckoutReason () {
      return this.$store.getters['swiftuser/getManualCheckoutReason'];
    },
  },
  methods: {
    checkOut () {
      this.loading = true;
      this.$store.dispatch('swiftuser/checkOutUser', {
        checkOutTime: {
          checkout_time: moment.utc().format(),
          type: this.checkoutType,
          manual_checkout_reason: this.manualCheckoutReason,
        },
        checkInId: this.activeCheckInDetails.id,
      }).then(response => {
        this.completeCheckOutProcess();
      }).catch(errors => {
        this.loading = false;
      });
    },
    async completeCheckOutProcess () {
      await this.$store.dispatch('swiftuser/sendVisitStatus', {
        statusDetails: {
          status: this.visitStatus.visit_status,
          pending_reason: this.visitStatus.pending_reason,
        },
        checkInId: this.activeCheckInDetails.id,
      }).then(response => {
        this.loading = false;
        this.$store.dispatch('alert/onAlert', {
          message: 'Check-Out completed successfully.',
          type: Constants.ALERT_TYPE_SUCCESS,
        });
        localStorage.removeItem('checkInTime');
        localStorage.removeItem('checkIn');
        this.$emit('checkout-completed');
      }).catch(() => {
        this.loading = false;
      });
    },
    cancel () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'HomePage' });
      }, 2000);
    },
  },
};
</script>
<style scoped>
.p-style {
  margin-left: 10px;
  color: #37474F;
  font-weight: bold;
  font-family: 'Times New Roman', Times, serif;
  font-size: 18px;
}
.card-style {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 5px;
  margin-right: 5px;
  padding-top: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.steps-name {
  font-size: 16px;
  font-weight: bold;
  color: #546E7A;
  margin-left: 10px;
  font-family:'Times New Roman', Times, serif;
}
.steps-div {
  line-height:normal;
  margin-left: 10px;
  border-left: 3px solid #FF3700;
}

.input__label {
   font-weight: bold;
  font-size: 16px;
  color: #37474F;
  font-family:'Times New Roman', Times, serif;
}
.user-content {
  font-size: 16px;
  font-weight: bold;
  color: #546E7A;
  margin-left: 15px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-family:'Times New Roman', Times, serif;
}
.reason-style {
  font-size: 16px;
  font-weight: bold;
  color: #546E7A;
  font-family:'Times New Roman', Times, serif;
}
.font-my-style {
  font-weight: bold;
  font-size: 16px;
  color: #37474F;
  font-family:'Times New Roman', Times, serif;
}
.user-card {
  border-left: 3px solid #546E7A !important;
  border-bottom: 3px solid #546E7A !important;
  padding-top: 5px;
  padding-bottom: 5px;
}
.invoice-Style {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: -10px;
  margin-top: 20px;
  color: #546E7A;
  font-family:'Times New Roman', Times, serif;
}
</style>
